import React, {useRef, useEffect} from "react"
import AOS from 'aos'
import 'aos/dist/aos.css'
import Banner from '../components/containers/banner'
import Layout from "../components/layout"
import SEO from "../components/seo"
import Section from "../components/section"
import MySlider from '../components/slider/slider';
import Integrations from '../components/integrations/integrations'
import Testar from '../components/testar'

const useMountEffect = (fun) => useEffect(fun, [])

const useScroll = () => {
  const htmlElRef = useRef(null)
  const executeScroll = () => {
    if(document.location.hash !== ''){
      window.scrollTo(0, (document.body.scrollHeight / 4))
    }
  
  }

  return [executeScroll, htmlElRef]
}

const IndexPage = () => {
  
  if (typeof window !== "undefined") {
    AOS.init({
      duration : 2000,
      mirror: true,
    });
    function setGETs(){
      var urlParams = new URLSearchParams(window.location.search);
      urlParams.forEach(function(value, key)  {
        writeCookie(key, value, 7)
      })

    }
    function writeCookie (key, value, days) {
      var date = new Date();
  
      // Default at 365 days.
      days = days || 365;
  
      // Get unix milliseconds at current time plus number of days
      date.setTime(+ date + (days * 86400000)); //24 * 60 * 60 * 1000
  
      window.document.cookie = key + "=" + value + "; expires=" + date.toGMTString() + "; path=/; domain=tagplus.com.br";
  
      return value;
    };
    setGETs();
  }
  
  const [executeScroll, elementToScrollRef] = useScroll()
  useMountEffect(executeScroll)
  
  return (
  <Layout>
    <SEO title="Home" />
    <Banner />
    <Section  effect={false} key={0} title="Integrações em " subtitle="Destaque" description="Conheça as principais integrações com o TagPlus e descubra como potencializar <br>suas vendas e alavancar a performance de sua empresa.">
      <MySlider />
    </Section>


 <Section key={1}  ref={elementToScrollRef} anchor="integracoes" title="Soluções para " subtitle="Integração" description="Confira a seguir as parcerias & soluções disponíveis na loja de aplicativos <br>que pode ser acessada no seu sistema TagPlus.">
   <div >
    <Integrations  />
   </div>
 </Section>

 <section id="testar" style={{
   marginTop: '5.4em'
 }}>
   <Testar />
 </section>

  </Layout>
)
}

export default IndexPage
 